/**
 * @enum {number}
 */
export const NOTIFICATION_STATUS = {
    CLOSED: 0,
    SUCCEED: 1,
    ERROR: 2,
    UNDO: 3
};

/**
 * @enum {number}
 */
export const PRE_JOIN_CONFIRM_DIALOG_TYPE = {
    NONE: 0,
    EXCLUSIVE: 1,
    AUTO_CHALLENGE: 2
};
